import React from "react";

import cn from "classnames";

import { Card, Space } from "antd";

import { DataDisclaimer } from "../data_disclaimer";

import styles from "./styles.module.scss";

export interface PageProps {
  title: React.ReactNode;
  description?: string;
  loading?: boolean;
  withoutCard?: boolean;
  containerClassName?: string;
  reportTTL?: number;
  report?: string;
}

export const Page: React.FC<PageProps> = (props) => {
  const { title, description, loading, withoutCard, reportTTL, containerClassName, children, report } = props;

  return (
    <>
      <div className={styles.info}>
        <h1 className={styles.title}>{title}</h1>
        {description && <h2 className={styles.description}>{description}</h2>}
        {reportTTL && report && <DataDisclaimer ttlDays={reportTTL} report={report} />}
      </div>
      <div className={cn([styles.container, containerClassName])}>
        {withoutCard ? (
          children
        ) : (
          <Card className={styles.card} loading={loading}>
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              {children}
            </Space>
          </Card>
        )}
      </div>
    </>
  );
};
